var ResourceHandle = /** @class */ (function () {
    function ResourceHandle() {
        var _this = this;
        this._resolve = function () {
            throw new Error('Cannot resolve this resource yet');
        };
        this._value = null;
        this.__alive = false;
        this.resolve = function (value) {
            _this._resolve(value);
            _this._value = value;
        };
        this.reset = function () {
            _this._resolve = function () {
                throw new Error('Cannot resolve this resource yet');
            };
            _this._promise = new Promise(function (resolve) {
                _this._resolve = resolve;
            });
            _this._value = null;
        };
        this._promise = new Promise(function (resolve) {
            _this._resolve = resolve;
        });
    }
    Object.defineProperty(ResourceHandle.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceHandle.prototype, "promise", {
        get: function () {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    return ResourceHandle;
}());
export { ResourceHandle };
//# sourceMappingURL=ResourceHandle.js.map